module.exports = __webpack_public_path__ + "img/PhotoCameraOutlined.878f9d40.svg";